module.exports = __webpack_public_path__ + "img/TalentPool.afa71e82.png";